import React from "react";

export function BackgroundBlueCheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3327 8.99967C17.3327 4.3973 13.6017 0.666342 8.99935 0.666342C4.39698 0.666342 0.666016 4.3973 0.666016 8.99967C0.666016 13.602 4.39698 17.333 8.99935 17.333C13.6017 17.333 17.3327 13.602 17.3327 8.99967Z"
        fill="#6399F8"
      />
      <path
        d="M5.66602 9.41667L7.74935 11.5L12.3327 6.5"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
